"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrinterModel = exports.PrinterConnectionType = exports.PrinterSerialHandshake = exports.PrinterSerialStopBits = exports.PrinterSerialParity = exports.PrinterMode = void 0;
var PrinterMode;
(function (PrinterMode) {
    // Default printing behavior
    PrinterMode[PrinterMode["Default"] = 0] = "Default";
    // Client printing only
    PrinterMode[PrinterMode["Local"] = 1] = "Local";
    // Star Cloud Printing only
    PrinterMode[PrinterMode["Cloud"] = 2] = "Cloud";
})(PrinterMode = exports.PrinterMode || (exports.PrinterMode = {}));
var PrinterSerialParity;
(function (PrinterSerialParity) {
    PrinterSerialParity[PrinterSerialParity["None"] = 0] = "None";
    PrinterSerialParity[PrinterSerialParity["Odd"] = 1] = "Odd";
    PrinterSerialParity[PrinterSerialParity["Even"] = 2] = "Even";
    PrinterSerialParity[PrinterSerialParity["Mark"] = 3] = "Mark";
    PrinterSerialParity[PrinterSerialParity["Space"] = 4] = "Space";
})(PrinterSerialParity = exports.PrinterSerialParity || (exports.PrinterSerialParity = {}));
var PrinterSerialStopBits;
(function (PrinterSerialStopBits) {
    PrinterSerialStopBits[PrinterSerialStopBits["None"] = 0] = "None";
    PrinterSerialStopBits[PrinterSerialStopBits["One"] = 1] = "One";
    PrinterSerialStopBits[PrinterSerialStopBits["Two"] = 2] = "Two";
    PrinterSerialStopBits[PrinterSerialStopBits["OnePointFive"] = 3] = "OnePointFive";
})(PrinterSerialStopBits = exports.PrinterSerialStopBits || (exports.PrinterSerialStopBits = {}));
var PrinterSerialHandshake;
(function (PrinterSerialHandshake) {
    PrinterSerialHandshake[PrinterSerialHandshake["None"] = 0] = "None";
    PrinterSerialHandshake[PrinterSerialHandshake["XOnXOff"] = 1] = "XOnXOff";
    PrinterSerialHandshake[PrinterSerialHandshake["RequestToSend"] = 2] = "RequestToSend";
    PrinterSerialHandshake[PrinterSerialHandshake["RequestToSendXOnXOff"] = 3] = "RequestToSendXOnXOff";
})(PrinterSerialHandshake = exports.PrinterSerialHandshake || (exports.PrinterSerialHandshake = {}));
var PrinterConnectionType;
(function (PrinterConnectionType) {
    PrinterConnectionType[PrinterConnectionType["HostAddress"] = 1] = "HostAddress";
    PrinterConnectionType[PrinterConnectionType["SerialPort"] = 2] = "SerialPort";
    PrinterConnectionType[PrinterConnectionType["PaymentTerminal"] = 3] = "PaymentTerminal";
    PrinterConnectionType[PrinterConnectionType["StarCloudPrint"] = 4] = "StarCloudPrint";
})(PrinterConnectionType = exports.PrinterConnectionType || (exports.PrinterConnectionType = {}));
var PrinterModel;
(function (PrinterModel) {
    PrinterModel[PrinterModel["Other"] = 0] = "Other";
    PrinterModel[PrinterModel["McPrint3"] = 1] = "McPrint3";
    PrinterModel[PrinterModel["TSP654II"] = 2] = "TSP654II";
})(PrinterModel = exports.PrinterModel || (exports.PrinterModel = {}));
